"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styled = require("../card/styled.card");

var _reactBootstrap = require("react-bootstrap");

var _data = require("./data");

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DummyProducts = function DummyProducts() {
  var _useState = (0, _react.useState)(_data2.default),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  return _react2.default.createElement(
    _react.Fragment,
    null,
    state.map(function (_ref) {
      var id = _ref.id,
          title = _ref.title,
          price = _ref.price,
          image = _ref.image;
      return _react2.default.createElement(
        _reactBootstrap.Col,
        { xs: 6, lg: 3, key: id },
        _react2.default.createElement(
          _styled.StyledCard,
          {
            className: "d-block position-relative product-image",
            href: title
          },
          _react2.default.createElement("img", { className: "d-block", src: image, alt: title })
        ),
        _react2.default.createElement(
          _styled.Info,
          { className: "info d-block p-3" },
          _react2.default.createElement(
            "a",
            { href: title, className: "d-block mb-1 product-title" },
            title
          ),
          _react2.default.createElement(
            "span",
            { className: "d-block price" },
            price,
            " "
          )
        )
      );
    })
  );
};
exports.default = DummyProducts;